module.exports = {
    CHAM_PERSONALIZED_CONTENT_GIG_PAGE: 2356,
    OWLS_FIVERR_CHOICE_EXPANSION: 2443,
    QUAL_SNIPPET_SORT_SAME_COUNTRY: 2514,
    FOXES_SHOW_MOBILE_BREADCRUMBS: 2518,
    FOXES_GIG_FOURTH_PACKAGE: 2520
};
